// extracted by mini-css-extract-plugin
export default {"dropdown":"ReportButtons_dropdown__bz1rL","buttonGroup":"ReportButtons_buttonGroup__GwPlW","frame16":"ReportButtons_frame16__kYH7-","frame16Text":"ReportButtons_frame16Text__vE3y5"};